import * as React from "react";
import { Box, LinearProgress, Modal, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function LoadingModal({ open }) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    width: 400,
    borderRadius: 5,
    boxShadow: 24,
    p: 4,
  };
  const { t } = useTranslation();

  return (
    <div>
      <Modal
        open={open}
        //onClose={handleClose}
        disableAutoFocus={true}
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography sx={{ mb: 4, userSelect: "none" }}>
              {t("loadingData")}
            </Typography>
            <LinearProgress color="secondary" />
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
